import { useRequest } from 'ahooks'

import usePopup from '../../HYBVant/HPopup/hooks/usePopup'

import { saveTraining, deletesTraining } from './service'

export default ({ value, onConfirm }: any) => {
  const { open, modalData, onCancel, onOpen } = usePopup({})
  // 奖惩记录 添加/编辑
  const { run: runSaveTraining, loading: saveTrainingLoading } = useRequest(saveTraining, {
    manual: true,
    onSuccess: (result: any) => {
      const { code } = result
      if (code === 2000) {
        onCancel()
        onConfirm()
      }
    },
    onError: ({ message }) => {
      console.log('error', message)
    }
  })

  // 奖惩记录 批量删除
  const { run: runDeleteTraining, loading: deleteTrainingLoading } = useRequest(deletesTraining, {
    manual: true,
    onSuccess: (result: any) => {
      const { code } = result
      if (code === 2000) {
        onCancel()
        onConfirm()
      }
    },
    onError: ({ message }) => {
      console.log('error', message)
    }
  })
  const add = () => {
    onOpen({ status: 'Add', editItem: {} })
  }

  const edit = (index: number) => {
    onOpen({ status: 'Edit', editItem: value?.[index] || {} })
  }

  return {
    add,
    edit,
    open,
    modalData,
    onCancel,
    onOpen,
    runDeleteTraining,
    runSaveTraining,
    deleteTrainingLoading,
    saveTrainingLoading
  }
}
